import { ReactNode } from "react";
import DOMPurify from "dompurify";
import s from "./style.module.scss";
import { CheckmarkIcon } from "../Icons/Checkmark";

type ListCheckmarkProps = {
  children?: ReactNode;
  dangerousHTML?: string;
};

export const ListCheckmark = ({
  children,
  dangerousHTML,
}: ListCheckmarkProps) => {
  const content = dangerousHTML ? (
    <span
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(dangerousHTML) }}
    />
  ) : (
    children
  );

  return (
    <li className={s.listCheckmark}>
      <span className={s.listCheckmark__icon}>
        <CheckmarkIcon />
      </span>
      {content}
    </li>
  );
};
